import { saveAs } from 'file-saver'
import { TFunction } from 'i18next'
import LicenseRestService from '../rest/LicenseRestService'

class LicenseService {
  static async getLicense() {
    return LicenseRestService.getLicense()
  }

  static async updateCustomerInfo(customerInfo: any, t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const trimmedCustomerInfo = JSON.parse(
        JSON.stringify(customerInfo, function replacer(_key, value) {
          // Filtering out properties
          if (typeof value === 'string') {
            return value.trim()
          }
          return value
        })
      )
      const updatedLicense = await LicenseRestService.updateCustomerInfo(trimmedCustomerInfo)
      setLicense(updatedLicense)
      return t('license.configureCustomerInfoSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteCustomerInfo(t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.deleteCustomerInfo()
      setLicense(updatedLicense)
      return t('license.deleteCustomerInfoSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async acquireLicense(licenseInfo: any, t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.acquireLicense(licenseInfo)
      setLicense(updatedLicense)
      return t('license.acquireLicenseSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async relinquishLicense(t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.relinquishLicense()
      setLicense(updatedLicense)
      return t('license.relinquishSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async processLicenseServerResponse(licenseInfo: any, t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const formData = new FormData()
      formData.append('responseFromServer', licenseInfo.responseFromServer)
      const updatedLicense = await LicenseRestService.processLicenseServerResponse(formData)
      setLicense(updatedLicense)
      return t('license.processLicenseServerResponseSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async acquireLicenseRequest(licenseInfo: any) {
    try {
      const acquireLicenseRequest: Blob = await LicenseRestService.acquireLicenseRequest(licenseInfo)
      saveAs(acquireLicenseRequest, 'AcquireLicenseRequest.req')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async verifyRequest() {
    try {
      const verifyRequest = await LicenseRestService.verifyRequest()
      saveAs(verifyRequest, 'VerifyLicenseRequest.req')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async relinquishLicenseRequest() {
    try {
      const relinquishLicenseRequest = await LicenseRestService.relinquishLicenseRequest()
      saveAs(relinquishLicenseRequest, 'FreeLicenseRequest.req')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteLicense(t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.deleteLicense()
      setLicense(updatedLicense)
      return t('license.deleteSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async offlineMode(t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.offlineMode()
      setLicense(updatedLicense)
      return t('license.offlineModeSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async onlineMode(t: TFunction, setLicense: React.Dispatch<any>) {
    try {
      const updatedLicense = await LicenseRestService.onlineMode()
      setLicense(updatedLicense)
      return t('license.onlineModeSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default LicenseService
